module.exports = __webpack_public_path__ + "img/nav-header-mobile-engagement.834d64c.webp";